import React from "react";
import { Modal } from "react-bootstrap";

import "./family-group-feedback-modal.scss";

const VARIANT_CONFIG = {
  revisionEnProceso: {
    icon: "quick_reference_all",
    iconClassName: "fg-feedback-modal__icon fg-feedback-modal__icon--review",
    title: "Revisión en proceso",
    body:
      "Cargamos los datos del integrante. Ahora el formulario está pendiente de revisión por el equipo del HB.",
    singleButton: true,
    confirmLabel: "Cerrar",
  },
  exito: {
    icon: "check_circle",
    iconClassName: "fg-feedback-modal__icon fg-feedback-modal__icon--success",
    title: "El integrante fue agregado al grupo familiar.",
    body: "Ya podés ver y gestionar su información.",
    singleButton: true,
    confirmLabel: "Cerrar",
  },
  exitoEdicion: {
    icon: "check_circle",
    iconClassName: "fg-feedback-modal__icon fg-feedback-modal__icon--success",
    title: "Los datos del integrante fueron actualizados.",
    body: "Ya podés ver y gestionar su información.",
    singleButton: true,
    confirmLabel: "Cerrar",
  },
  desvincular: {
    icon: "error",
    iconClassName: "fg-feedback-modal__icon fg-feedback-modal__icon--warning",
    title:
      "¿Estás seguro que querés desvincular a esta persona de tu Grupo Familiar?",
    body: null,
    singleButton: false,
    cancelLabel: "Cancelar",
    confirmLabel: "Desvincular",
  },
};

export const FamilyGroupFeedbackModal = ({
  show = false,
  variant = "revisionEnProceso",
  onClose,
  onConfirm,
}) => {
  const config = VARIANT_CONFIG[variant] ?? VARIANT_CONFIG.revisionEnProceso;

  const handleClose = () => {
    onClose?.();
  };

  const handleConfirm = () => {
    if (variant === "desvincular") {
      onConfirm?.();
      return;
    }
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="fg-feedback-modal"
      contentClassName="fg-feedback-modal__content"
      backdropClassName="fg-feedback-modal__backdrop"
    >
      <Modal.Body className="fg-feedback-modal__body">
        <div className="fg-feedback-modal__inner">
          <div className="fg-feedback-modal__message">
            <span
              className={`material-symbols-outlined ${config.iconClassName}`}
              aria-hidden="true"
            >
              {config.icon}
            </span>
            <div className="fg-feedback-modal__text">
              <p className="fg-feedback-modal__title">{config.title}</p>
              {config.body ? (
                <p className="fg-feedback-modal__description">{config.body}</p>
              ) : null}
            </div>
          </div>

          <div
            className={`fg-feedback-modal__actions${
              config.singleButton ? " fg-feedback-modal__actions--single" : ""
            }`}
          >
            {!config.singleButton ? (
              <button
                type="button"
                className="fg-feedback-modal__button fg-feedback-modal__button--secondary"
                onClick={handleClose}
              >
                {config.cancelLabel}
              </button>
            ) : null}
            <button
              type="button"
              className="fg-feedback-modal__button fg-feedback-modal__button--primary"
              onClick={handleConfirm}
            >
              {config.confirmLabel}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
